import { IconButton, Box, Tooltip } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";

const FloatingHomeButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/", { state: { scrollToId: null } });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Tooltip title="Home">
      <Box
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          zIndex: 1000,
        }}
      >
        <IconButton
          onClick={handleClick}
          sx={{
            backgroundColor: "#1B2E85",
            color: "white",
            "&:hover": {
              backgroundColor: "#142063",
            },
          }}
        >
          <HomeIcon />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default FloatingHomeButton;
